import React from 'react';
import Product from '../Product';

function TShirts () {
   
    return (
        <div>
            <div>
                <Product title="TShirts" start={11} end={17} />
            </div>
        </div>
    )
}

export default TShirts;